import * as ko from 'knockout';
import template from './button.html';
import type { HyperlinkModel } from '../../../permalinks/hyperlinkModel';
import { Component } from '@paperbits/common/ko/decorators';
import type { StyleModel } from '@paperbits/common/styles';


@Component({
    selector: 'paperbits-button',
    template: template
})
export class Button {
    public readonly label: ko.Observable<string>;
    public readonly ariaLabel: ko.Observable<string>;
    public readonly styles: ko.Observable<StyleModel>;
    public readonly hyperlink: ko.Observable<HyperlinkModel>;
    public readonly icon: ko.Observable<string>;
    public readonly roles: ko.ObservableArray<string>;
    public readonly language: ko.Observable<string>;
    public readonly id: ko.Observable<string>;
    public readonly formDownload: ko.Observable<boolean>;

    constructor() {
        this.label = ko.observable<string>('Button');
        this.ariaLabel = ko.observable<string>();
        this.styles = ko.observable<StyleModel>();
        this.hyperlink = ko.observable<HyperlinkModel>();
        this.icon = ko.observable<string>();
        this.roles = ko.observableArray<string>();
        this.language = ko.observable<string>();
        this.id = ko.observable<string>();
        this.formDownload = ko.observable<boolean>();
    }
}